<template>
  <div>
    <div class="">
      <div v-if="!solution.isVisible">
        <span class="has-text-grey p-1 pb-5 is-block has-text-centered">Result hidden by travel policy</span>
      </div>
      <div v-if="solution.isVisible" class="box pb-0" style="margin-bottom:1rem">
        <div class="columns mb-0">


          <div class="column wrap is-3 has-text-centered noPadding">

            <img  width="370" :src="photo(solution.vehicleInfo.photo)">

            <img  v-if="puLocation.logo" class="mt-5" style="border-radius: 3px; height: 45px;" :src="puLocation.logo">
            <span v-else class="mt-5">{{ solution.companyInfo.name }}</span>

          </div>
          <div class="noPadding column wrap">

            <div class="columns mb-0 is-mobile">
              <div class="column">
                <PreferredVendorTag v-if="isPreferredVendor" type="car"></PreferredVendorTag>

                <div class="has-text-black" style="font-size: 1.5em;">{{ solution.vehicleInfo.displayName}}</div>                
                <div class="has-text-grey-light">{{ solution.vehicleInfo.model}}</div>
                <b-tag style="margin:0rem 1rem 1rem 0rem; border:0rem; font-size: 1rem;">
                  <span >  {{  solution.vehicleInfo.passengers  }}</span><b-icon  icon="account"></b-icon>
                </b-tag>
                <b-tag style="margin:1rem 1rem 0rem 0rem; border:0rem; font-size: 1rem;">
                  <span>  {{  solution.vehicleInfo.doors  }}</span><b-icon icon="car-door"></b-icon>
                </b-tag>
              </div>
              <div class="column is-narrow" >
                <div class="columns mb-0">

                  <div class="column is-narrow"  style="margin-left: -5px;">

                    <OutOfPolicyTag position="is-bottom" style="width: 100px;" :travelPolicy="solution.travelPolicy"></OutOfPolicyTag>
                    <!-- Immediate travel -->
                    <div v-if="solution.immediateTravelBookingAdvice">
                      <ImmediateTravelNote :severity="solution.immediateTravelBookingAdvice"></ImmediateTravelNote>
                    </div>
                    <!-- End Immediate travel -->
                    <b-button class="is-pulled-right mt-1" style="width: 100px;" size="is-small" type="is-secondary" @click="carRateModal(solution, searchBody)">Rate Details</b-button>
                  </div>

                  <div class="column is-narrow">
                    <div class="is-size-4 has-font-weight-bold has-text-right">
                  {{ solution.pricingInfo.total.toFixed(0) | formatPriceFromDollars }}

                  <p style="font-size: 14px; color: gray;">
                    {{ solution.pricingInfo.averagePricePerDay.toFixed(0) | formatPriceFromDollars }}/day
                  </p>

                </div>
              </div>

            </div>

            <div  class="buttons is-pulled-right mt-0">


              <div v-if="!solution.isSelectable" class="is-size-7 has-text-grey">
                Not selectable
              </div>

              <div v-if="solution.isSelectable && solution.immediateTravelBookingAdvice == 'prevent'" class="mt-4 notification is-size-7 has-text-grey has-text-centered">
                To book this option call: <br> 877-924-0303
              </div>
              <b-button v-if="solution.isSelectable && solution.immediateTravelBookingAdvice != 'prevent'" class="is-primary" @click="checkSubmission()"><b>SELECT</b></b-button>

            </div>

          </div>
            </div>

            <div class="columns is-gapless is-mobile locationSummary">
              <div class="column is-narrow" >
                <RentalLocationSummary :location="puLocation" :occursAt="solution.pickupInfo.dateTime" rentalEndpoint="Pick-Up" :mainPage="true" @selected="selectLocation('Pick-Up')"></RentalLocationSummary>
              </div>
              <div class="column is-narrow">
                <RentalLocationSummary :location="doLocation" :occursAt="solution.dropoffInfo.dateTime" rentalEndpoint="Drop-Off" :mainPage="true" @selected="selectLocation('Drop-Off')"></RentalLocationSummary>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let md5 = require('md5');

  import OutOfPolicyTag from '../../Tags/OutOfPolicyTag.vue';
  import PreferredVendorTag from '../../Tags/PreferredVendorTag.vue';
  import HourSchedule from './HourSchedule.vue';
  import GMap from "../../GMap/GMap";
  import CarDetails from "./CarDetails";
  import RentalLocationSummary from "./RentalLocationSummary";
  import ImmediateTravelNote from "../../Traveller/ImmediateTravelNote";
  import bookingMixin from "@/mixins/bookingMixin";
  import meetingsMixin from "@/mixins/meetingsMixin";
  import modalMixin from "@/mixins/modalMixin";

  export default {
    name: 'Result',
    mixins: [bookingMixin, meetingsMixin, modalMixin],
    components: {
      OutOfPolicyTag,
      PreferredVendorTag,
      RentalLocationSummary,
      ImmediateTravelNote,
    },
    props: {
      solution: Object,
      puLocation: Object,
      doLocation: Object,
      session: String,
      searchBody: Object,
      searchDetails: Object,
      preferredVendors:Array
    },
    data: function () {
      return {
        display_full: false,
        path: "",
        time: "",
        price: "",
        score: "",
        stops: [],
        none: 'https://none',
      }
    },
    computed: {
      triptype(){
        return this.$store.state.bookTravel.result.itineraryType;
      },
      triggerMessages(){
        var message = '';
        for (let i = 0; i < this.solution.travelPolicy.rulesTriggered.length; i++) {
          message += this.solution.travelPolicy.rulesTriggered[i].message + '  |  '
        }
        return message
      },
      rentalTypeIcon() {
        //return this.puLocation == this.doLocation ? 'autorenew' : 'arrow-right'
        return 'arrow-right'
      },
      isPreferredVendor(){
        return this.solution.isPreferred;
        //return this.preferredVendors.includes(this.solution.companyInfo.code);
      }
    },
    methods: {
      checkSubmission() {
        if (this.solution.immediateTravelBookingAdvice == 'warn') {

          this.$buefy.dialog.confirm({
            message: 'You have selected a car with a pick-up time in the next few hours. Please watch your email for your Final Itinerary.  If you do not receive your Final Itinerary, please contact Gant Travel Support at 877-924-0303 for assistance.',
            confirmText: 'Continue booking',
            type: 'is-info',
            hasIcon: true,
            onConfirm: () => this.submitted()
          })

        } else {
          this.submitted()
        }
      },
      submitted(){
        this.solution.locationInfo = this.puLocation;
        this.solution.searchBody = this.searchBody
        this.solution.pickupLocation = this.puLocation;
        this.solution.dropoffLocation = this.doLocation;
        this.solution.companyInfo.name = this.$helpers.capitalize(this.solution.companyInfo.name);
        this.solution.vehicleInfo.photo = this.photo(this.solution.vehicleInfo.photo);
        this.solution.searchDetails = this.searchDetails
        this.$store.dispatch('bookTravel/alterCarResult',this.solution)
        if (this.pathMixin_isMeeting){
          this.meetingRouter()
        }
        else{
          this.$nav.pushRouteTo({ name: 'BookingItinerary'})
        }
      },
      display() {
                  this.display_full= !this.display_full
              },
      photo(url){
                if (url == this.none || !url){
                  return "/images/default-car.png"
                }
                else{
                  return url
                }
              },
      goToDetails(location) {
                var details = {
                    parent: this,
                    component: CarDetails,
                    props: {
                      "location": location
                  },
                    hasModalCard: true,
                    trapFocus: true,
                    width: 800
                }
                  this.$buefy.modal.open(details)
                },
      goToMaps(lat, long) {
                var details = {
                    parent: this,
                    component: GMap,
                    props: {
                      "lat": lat,
                      "long": long,
                      "width": '700',
                      "height": '600',
                      'image': this.puLocation.logo
                  },
                    hasModalCard: true,
                    trapFocus: true,
                    width: 700
                }
                  this.$buefy.modal.open(details)
                },
      goToHours(location) {
                  var details = {
                      parent: this,
                      component: HourSchedule,
                      props: {
                        "hours": location.hours,
                        "name": location.name,
                        "address": location.address,
                        "logo": location.logo,
                    },
                      hasModalCard: true,
                      trapFocus: true,
                      width: 400
                  }
                    this.$buefy.modal.open(details)
                  },
      selectLocation(val){
                    // console.log('here')
                    if(val == 'Drop-Off'){
                      this.$emit('dropoffSelected')
                    }
                    else{
                      this.$emit('pickupSelected')
                    }

                  }
    },
    mounted() {
    }
  }
</script>

<style lang="scss" scoped>
</style>
